import { Injectable } from '@angular/core';

@Injectable()
export class ScreenReaderLiveService {
    private _el: HTMLElement;

    constructor() {
        this._el = document.createElement('div');
        this._el.classList.add('sr-only');
        this._el.setAttribute('aria-live', 'polite');
        this._el.setAttribute('aria-atomic', 'true');
        document.body.appendChild(this._el);
    }

    announce(message: string): void {
        this._el.textContent = '';
        // eslint-disable-next-line no-return-assign
        window.setTimeout(() => (this._el.textContent = message), 200);
    }
}
